import React, { useEffect, useState } from "react";

import ReactDOM from "react-dom";
import Categories from "./Categories";
import Filters from "./Filters";
import Search from "./Search";
import List from "./List";
import { SpinnerComponent } from "react-element-spinner";
import { SortOrder } from "./SortOrder";

class ListPage {
  constructor(element) {
    this.element = element;
    this.view = element.querySelector(".js-newlist-page__root");
    this.init();
  }

  init() {
    ReactDOM.render(<ListPageView />, this.view);
  }
}

const ListPageView = () => {
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState([]);
  const [activeFilters, setActiveFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [certificates, setCertificates] = useState([]);
  const [statements, setStatements] = useState([]);
  const [others, setOthers] = useState([]);
  const [products, setProducts] = useState([]);
  const [numberOfItems, setNumberOfItems] = useState(10);

  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState(null);

  const translations = filters?.Translations;

  const loadMoreText = translations?.find(
    (translation) => translation.Key === "LoadMoreButton"
  );

  useEffect(() => {
    const fetchUrl = `${episerver_listEndpoint}allfilterdata/${episerver_local}`;

    const fetchSettings = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    fetch(fetchUrl, fetchSettings)
      .then((res) => res.json())
      .then((filters) => {
        setFilters(filters);
      });
  }, []);

  useEffect(() => {
    let timeoutId;
    const certificatesIds = certificates.length > 0 ? certificates : "null";
    const statementsIds = statements.length > 0 ? statements : "null";
    const otherIds = others.length > 0 ? others : "null";
    const productIds = products.length > 0 ? products : "null";
    const query = searchQuery.length > 0 ? searchQuery : "null";
    const order = sortOrder !== null ? sortOrder?.SysName : "PublishDateDesc";
    const fetchUrl = `${episerver_listEndpoint}getitems/${episerver_currentContainerId}/${episerver_local}/${certificatesIds}/${statementsIds}/${otherIds}/${productIds}/${query}/${numberOfItems}/0/${order}`;

    const fetchSettings = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const delayDuration = 500;

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      setIsLoading(true);
    }, delayDuration);

    fetch(fetchUrl, fetchSettings)
      .then((res) => res.json())
      .then((items) => {
        clearTimeout(timeoutId);
        setIsLoading(false);
        setItems(items);
      });

    return () => {
      clearTimeout(timeoutId);
    };
  }, [activeFilters, numberOfItems, searchQuery, sortOrder]);

  const handleFilters = (filter) => {
    if (activeFilters.includes(filter)) {
      setActiveFilters(activeFilters.filter((f) => f !== filter));
    } else {
      setActiveFilters([...activeFilters, filter]);
    }
    if (filter.CertificateName && !certificates.includes(filter.ID)) {
      setCertificates((certificates) => [...certificates, filter.ID]);
    } else if (filter.CertificateName && certificates.includes(filter.ID)) {
      setCertificates(certificates.filter((c) => c !== filter.ID));
    }
    if (filter.StatementName && !statements.includes(filter.ID)) {
      setStatements((statements) => [...statements, filter.ID]);
    } else if (filter.StatementName && statements.includes(filter.ID)) {
      setStatements(statements.filter((s) => s !== filter.ID));
    }
    if (filter.OtherName && !others.includes(filter.ID)) {
      setOthers((others) => [...others, filter.ID]);
    } else if (filter.OtherName && others.includes(filter.ID)) {
      setOthers(others.filter((o) => o !== filter.ID));
    }
    if (filter.Name && !products.includes(filter.ContentID)) {
      setProducts((products) => [...products, filter.ContentID]);
    } else if (filter.Name && products.includes(filter.ContentID)) {
      setProducts(products.filter((p) => p !== filter.ContentID));
    }
  };

  return (
    <div className="pagecomponent--70 list-page-new__view">
      <Search
        searchQuery={searchQuery}
        setSearchQuery={(query) => setSearchQuery(query)}
        translations={translations}
      />
      <Categories
        filters={filters}
        activeFilters={activeFilters}
        handleFilters={(filter) => handleFilters(filter)}
        translations={translations}
      />
      <Filters
        activeFilters={activeFilters}
        handleFilters={(filter) => handleFilters(filter)}
      />
      {isLoading ? (
        <SpinnerComponent
          loading={isLoading}
          spinnerType="circle-dots"
          position="centered"
          backgroundColor="#dddddd"
        />
      ) : (
        <>
          <SortOrder
            sortOrder={sortOrder}
            setSortOrder={(order) => setSortOrder(order)}
            options={filters.SortingOptions}
            translations={translations}
          />
          <List list={items} translations={translations} />
          {items.length >= numberOfItems && (
            <button
              className="cta btn btn-Black"
              style={{ marginInline: "auto" }}
              onClick={() => setNumberOfItems(numberOfItems + 10)}
            >
              {loadMoreText?.Translation}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default ListPage;
